import { render, staticRenderFns } from "./RunningContestTab.vue?vue&type=template&id=898c72cc"
import script from "./RunningContestTab.vue?vue&type=script&lang=js"
export * from "./RunningContestTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports